import { closeWebview, isBlibliAndroidUserAgent, redirectToFullUrl, isFromTiket } from '@/utils/browser.js'
import { ternary } from '@/utils/common.js'
import { getBlibliTiketOriginSource } from '@/utils/tenant.js'

const redirectMapping = {
  BLIBLI: `${window._BLIBLI_DOMAIN}`,
  TIKET: `${window._TIKET_DOMAIN}`
}

async function sendNativeCommand (command, previousRouteCount, callback) {
  const webviewArgs = JSON.stringify({ command })

  if (isFromTiket()) {
    history.go(previousRouteCount)
    return
  }

  if (typeof window.generic?.callGenericNativeJSI === 'function') {
    await window.generic.callGenericNativeJSI(webviewArgs)
    return
  }

  if (typeof window.webkit?.messageHandlers?.callNativeJSI?.postMessage === 'function') {
    await window.webkit.messageHandlers.callNativeJSI.postMessage(webviewArgs)
    return
  }

  if (typeof window.ReactNativeWebView?.postMessage === 'function') {
    await window.ReactNativeWebView.postMessage(webviewArgs)
    return
  }

  if (isBlibliAndroidUserAgent()) {
    closeWebview()
    return
  }

  if (typeof callback === 'function') {
    callback()
  }
}

const redirectBackToTenant = (previousRouteCount = -1) => {
  sendNativeCommand('closeWebView', previousRouteCount, () => {
    const tenantId = getBlibliTiketOriginSource()
    redirectToFullUrl(redirectMapping?.[tenantId])
  })
}

const redirectToLogin = (page) => {
  const AFFILIATE_IDENTIFIER = '/member/affiliate'
  const path = ternary(page, AFFILIATE_IDENTIFIER + page + '?appsWebview=true&redirect=true', window._LOGIN_REF_PATH)
  const separator = window._LOGIN_URL.includes('?') ? '&' : '?'
  redirectToFullUrl(`${window._LOGIN_URL}${separator}ref=${encodeURIComponent(path)}`)
}

const redirectToBridge = () => {
  redirectToFullUrl(window._BRIDGE_URL)
}

const domainByTenantId = (tenantId) => {
  if (process.env.NODE_ENV === 'development') {
    return 'https://'
  } else {
    return redirectMapping?.[tenantId]
  }
}

export {
  domainByTenantId,
  redirectBackToTenant,
  redirectToBridge,
  redirectToLogin
}
